var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 12.4C20 12.2 20 11.9 19.9 11.6C19.8 11.5 19.8 11.4 19.7 11.3L12.7 4.3C12.3 3.9 11.7 3.9 11.3 4.3C10.9 4.7 10.9 5.3 11.3 5.7L16.6 11H5C4.4 11 4 11.4 4 12C4 12.6 4.4 13 5 13H16.6L11.3 18.3C10.9 18.7 10.9 19.3 11.3 19.7C11.5 19.9 11.8 20 12 20C12.2 20 12.5 19.9 12.7 19.7L19.7 12.7C19.8 12.6 19.9 12.5 19.9 12.4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowRight.31cfc13a055c2fd77a420169486d0f89.svg";